import { getZone, hasZone } from '../../content';
import type { ZoneLayout } from '../../zones/types';
import { OVERWORLD_IDS, type WaystoneInfo, waystonesIn } from './waystones';

/**
 * Registered overworld zone layouts (built lazily and cached by the content
 * registry). A zone whose builder throws is skipped so one broken layout
 * can't take the panels down with it.
 */
export function layoutOrNull(id: string): ZoneLayout | null {
  try {
    return hasZone(id) ? getZone(id) : null;
  } catch (e) {
    console.warn(`Zone '${id}' failed to build`, e);
    return null;
  }
}

export function overworldLayouts(): ZoneLayout[] {
  return OVERWORLD_IDS.map(layoutOrNull).filter((z): z is ZoneLayout => !!z);
}

let cache: { key: string; list: WaystoneInfo[] } | null = null;

/** Every waystone in the registered overworld, in map order. */
export function allWaystones(): WaystoneInfo[] {
  const key = OVERWORLD_IDS.filter(hasZone).join(',');
  if (cache?.key !== key) cache = { key, list: overworldLayouts().flatMap(waystonesIn) };
  return cache.list;
}
